<template>
    <div>
      <div class="options-title">
        <div class="options-title__left">
          <p class="color-title">цвет</p>
          <p class="quantity-title">кол-во</p>
        </div>
      </div>

      <div class="options-list">
        <div class="color">
          <div class="options-list__item" v-for="(colorItem, colorIndex) in colorList" :key="colorIndex">
            <p class="color-hex" v-bind:style="{ backgroundColor: colorItem.colorHex }"></p>
            <span>{{ colorItem.colorName }}</span>
            <div class="input-block">
              <span class="minus" @click="minus(colorItem.colorID)"></span>
              <input type="number" @change="setQuantity(colorItem.quantity, colorItem.colorID)" min="0" v-model="colorItem.quantity" />
              <span class="plus" @click="plus(colorItem.colorID)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: ['colorList', 'element'],
  data: () => ({

  }),
  methods: {
    setQuantity(value, colorID){
      for(var key in this.colorList){
        let colorItem = this.colorList[key];
        if( parseInt(colorItem.colorID) == colorID){
          colorItem.quantity = value;
          this.localStorageUpdate(this.element, colorItem)
        }
      }
    },
    plus(colorID){
      for(var key in this.colorList){
        let colorItem = this.colorList[key];
        if( parseInt(colorItem.colorID) == colorID){
          colorItem.quantity++;
          this.localStorageUpdate(this.element, colorItem)
        }
      }
    },
    minus(colorID){
      for(var key in this.colorList){
        let colorItem = this.colorList[key];
        if( parseInt(colorItem.colorID) == colorID){
          if(colorItem.quantity > 0){
            colorItem.quantity--;
            this.localStorageUpdate(this.element, colorItem)
          }else{
            colorItem.quantity = 0;
            this.localStorageUpdate(this.element, colorItem)
          }
        }
      }
    },
    localStorageUpdate(productId, cartItem){
      productId = 'productId_' + productId;
      let miniCart = this.$localStorageGet('miniCart');
      
      if(Object.keys(miniCart).length == 0){
        miniCart[productId] = [];
        miniCart[productId].push(cartItem);
        this.$localStorageSet('miniCart', miniCart)
      }else{
        this.updateMiniCart(miniCart, productId, cartItem)
      }
    },
    updateMiniCart(miniCart, productId, cartItem){

      if(miniCart[productId]){ //Если в миникорзине есть такой товар
        let currentOption = miniCart[productId].find(x => x.colorID == cartItem.colorID); //Выбранный цвет
        if(currentOption){ //Если в миникорзине есть товар и у него уже есть выбранный цвет
          currentOption.quantity = cartItem.quantity; //Обновить количество
          if(cartItem.quantity == 0){  //Если количество 0, удалить опцию из миникорзины
            miniCart[productId] = miniCart[productId].filter((item) => item.colorID != cartItem.colorID);
          }
          if(Object.keys(miniCart[productId]).length == 0){ //Если опции совсем не выбраны, удалить товар полностью из миникорзины
            delete miniCart[productId];
          }
          else if(Object.keys(miniCart[productId]).length == 1 && miniCart[productId][0]['rating'] != undefined){
            delete miniCart[productId];
          }
          
          this.$localStorageSet('miniCart', miniCart); //Перезаписать миникорзину в localStorage
        }else{ //Если товар есть, а цвета нет
          miniCart[productId].push(cartItem) //добавить новый выбранный цвет
          this.$localStorageSet('miniCart', miniCart); //Перезаписать миникорзину в localStorage
        }

      }else{ //Если в миникорзине нет такого товара
        miniCart[productId] = []; 
        miniCart[productId].push(cartItem); //Добавить новый товар и выбранный цвет к нему
        this.$localStorageSet('miniCart', miniCart); //Перезаписать миникорзину в localStorage
      }

    }
  }
};
</script>